import type { LessonsStore } from './interfaces'

import { emptyLessonsFilters } from '../../../lib/lessons-query'

const LESSONS_DEFAULT_PER_PAGE = 25

export const createLessonsState = (): LessonsStore => ({
  loading: false,
  lessons: [],
  meta: null,
  filters: emptyLessonsFilters(),
  currentPage: 1,
  perPage: LESSONS_DEFAULT_PER_PAGE,
  selectedIds: [],
  deleteModal: null,
  activeLesson: null,
  deleting: false,
  slots: null,
  actionModal: null,
  actionLesson: null,
})
